import Shader from './Shader';
import * as Uniform from '../Uniform';
import FRAG_VIEWER from './Fragment/viewer.frag';
import VERT_VIEWER from './Vertex/viewer.vert';

export default class ViewerShader extends Shader {
	public u_viewerInputSize:Uniform.Uniform2f;
	public u_viewerSize:Uniform.Uniform2f;
	public u_offset:Uniform.Uniform2f;
	public u_dpi:Uniform.Uniform1f;
	public u_grid:Uniform.Uniform1i;
	public u_overlay:Uniform.Uniform1i;
	public u_rulers:Uniform.Uniform1i;
	public u_previewFabric:Uniform.Uniform1i;
	public u_previewFabricSize:Uniform.Uniform2f;
	public u_repeatMode:Uniform.Uniform1i;
	public u_flipy:Uniform.Uniform1i;
	public u_units:Uniform.Uniform1i;

	public frag = ():string => FRAG_VIEWER;
	public vert = ():string => VERT_VIEWER;
}